import Vue from 'vue';
import { BIcon, BIconX, BIconStars, BIconCoin, BIconGiftFill, BIconEmojiSmile } from 'bootstrap-vue';

// Only the Bootstrap icons the app uses are bundled. When a template uses a
// new <b-icon icon="name">, import and register BIcon<Name> here, otherwise
// the icon renders empty.
const ICONS = { BIconX, BIconStars, BIconCoin, BIconGiftFill, BIconEmojiSmile };

export function installIcons() {
    Vue.component('BIcon', BIcon);
    Object.entries(ICONS).forEach(([name, component]) => Vue.component(name, component));
}
